// extracted by mini-css-extract-plugin
export var block = "content-module--block--133Sc";
export var zzz = "content-module--zzz--1Skj_";